<template>
  <div v-if="loadEntity">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6" >
      <card class="bg-transparent" >
        <template slot="header">
          <div>
            <div>
              <h3 class="mb-0">{{ entityName }}</h3>
              <p class="text-sm mb-0">
                Details
              </p>
            </div>
          </div>
        </template>
        <b-tabs pills v-model="tabIndex">
          <b-tab key="Calendar" title="Calendar">
            <p/>
            <period-filter :show-group="false" />
            <div>
              <entity-interval :type="this.type" :entity-id="this.entityId" @showtrips="tabIndex = 1"></entity-interval>
            </div>
          </b-tab>
          <b-tab key="Trips" title="Trips" lazy>
            <p/>
            <div>
              <entity-trips :type="this.type" :entityId="this.entityId" />
            </div>
          </b-tab>
          <b-tab key="DrivingStyle" title="Driving style" lazy>
            <p/>
            <period-filter :show-group="false" />
            <div>
              <driving-style-stats :type="this.type" :ids="[ this.entityId ]" ></driving-style-stats>
            </div>
          </b-tab>
          <b-tab key="Media" title="Media" lazy>
            <p/>
            <period-filter :show-group="false" />
            <div>
              <entity-media :type="this.type" :entityId="this.entityId" ></entity-media>
            </div>
          </b-tab>
          <b-tab key="Monitoring" title="Monitoring" v-if="type === 'ASSET' && $store.state.auth.user.user_role !== 'DRIVER'" lazy>
            <p/>
            <period-filter :show-group="false" />
            <div>
              <entity-monitorings :type="this.type" :entityId="this.entityId" ></entity-monitorings>
            </div>
          </b-tab>
          <b-tab key="Heatmap" title="Heatmap" lazy>
            <p/>
            <period-filter :show-group="false" />
            <div>
              <entity-heatmap :type="this.type" :entityId="this.entityId" ></entity-heatmap>
            </div>
          </b-tab>
          <b-tab key="RawData" title="Raw data" v-if="type === 'ASSET' && ($store.state.auth.user.user_role === 'OEM' || $store.state.auth.user.user_role === 'INTEGRATOR')" lazy>
            <p/>
            <period-filter :show-group="false" />
            <div>
              <entity-raw-data :asset-id="[ this.entityId ]" ></entity-raw-data>
            </div>
          </b-tab>
        </b-tabs>
      </card>
    </b-container>
  </div>
</template>

<script>
import DrivingStyleStats from "../DrivingStyle/DrivingStyleStats";
import crudApi from "../../crud/crud-api";
import PeriodFilter from "../DrivingStyle/PeriodFilter";
import EntityTrips from "../DrivingStyle/EntityTrips";
import EntityInterval from "../DrivingStyle/EntityInterval";
import EntityHeatmap from "../DrivingStyle/EntityHeatmap";
import EntityRawData from "../DrivingStyle/EntityRawData";
import EntityMedia from "../DrivingStyle/EntityMedia";
import EntityMonitorings from "../DrivingStyle/EntityAssetMonitorings";

export default {
  name: "entity-detail",
  components: {
    PeriodFilter,
    DrivingStyleStats,
    EntityTrips,
    EntityInterval,
    EntityHeatmap,
    EntityRawData,
    EntityMedia,
    EntityMonitorings
  },
  props: {
    type: {
      type: String,
      default: 'ASSET',
      description: "Types : ASSET, DRIVER"
    },
    entityId: {
      type: String,
      required: true,
      description: "Entity ID"
    },
  },
  data: _ => ({
    entity: {},
    tabIndex: 0
  }),
  computed: {
    loadEntity() {
      this.getEntity()

      return true
    },
    entityName() {
      if (this.type === 'ASSET') {
        return this.entity.name
      } else {
        return this.entity.firstName + ' ' + this.entity.lastName
      }
    }
  },
  methods: {
    getEntity() {
      if (this.type === 'ASSET') {
        crudApi.getAsset(this.entityId).then(json => this.entity = json.data ? json.data : json)
      } else {
        crudApi.getDriver(this.entityId).then(json => this.entity = json.data ? json.data : json)
      }
    }
  }
}
</script>

<style scoped>

</style>

